import { connect } from 'react-redux';
import CardActionsCell from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(CardActionsCell);
